var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlLegs4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1258,
    viewBox: "0 0 1160 1258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Legs / 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.06 1144.54L578.863 1102.63L536.675 1083.04L532.301 1203.09L697.001 1202.81C663.412 1167.97 574.06 1144.54 574.06 1144.54ZM328.848 1091.18L282.169 1092.19L282.641 1145.55C282.641 1145.55 237.605 1153.36 222 1203.1H339.09L334.016 1143.17L328.848 1091.18Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.912 1094.14L288.378 1078.14L282.279 1143.17L333.654 1145.55L333.912 1094.14ZM579.961 1109.75L535.705 1092.16L534.345 1142.88L579.581 1144.55L579.961 1109.75Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants_2",
    d: "M272.141 1102.84C274.228 1037.82 287.708 627.091 301.559 382.731C311.157 213.361 382.986 120.112 396.467 104H567.612C567.924 106.163 590.961 269.234 595.177 610.45C598.962 916.029 595.06 1083.06 594.572 1102.7L594.572 1102.71L600.038 1102.7L600.073 1129.01L511.449 1129.15L511.414 1102.84L514.47 1102.84L514.47 1102.84L469.466 568.098L455.986 408.053L353.666 1102.7L353.665 1102.71L358.09 1102.7L356.545 1129L264.791 1129.15L266.336 1102.85L272.141 1102.84L272.141 1102.84Z",
    fill: "#2F2F3D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    opacity: 0.398065,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.986 408.059L474.4 251.498L469.461 568.095L455.986 408.059Z",
    fill: "#0A0A0F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlLegs4);
export default __webpack_public_path__ + "static/media/Girl-Legs-4.087e40fe.svg";
export { ForwardRef as ReactComponent };